module.exports = "/assets/data/f6b27225f28879003ad20230afad96a8-WF3.data.json";